namespace TabAurous.Scheme {
    export interface SchemePaymentForm {
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        CustomerName: Serenity.StringEditor;
        Mobile: Serenity.IntegerEditor;
        Address: Serenity.TextAreaEditor;
        PanNumber: Serenity.StringEditor;
        SchemeId: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        LedgerId: Serenity.LookupEditor;
        SchemePaymentDetails: SchemePaymentDetailsEditor;
    }

    export class SchemePaymentForm extends Serenity.PrefixedContext {
        static formKey = 'Scheme.SchemePayment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SchemePaymentForm.init)  {
                SchemePaymentForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = SchemePaymentDetailsEditor;

                Q.initFormType(SchemePaymentForm, [
                    'TransDate', w0,
                    'VoucherNo', w1,
                    'POSCustomerId', w2,
                    'CustomerName', w1,
                    'Mobile', w3,
                    'Address', w4,
                    'PanNumber', w1,
                    'SchemeId', w5,
                    'Amount', w6,
                    'LedgerId', w5,
                    'SchemePaymentDetails', w7
                ]);
            }
        }
    }
}
